import React from "react";
import { motion } from "framer-motion";
import {
  FiSearch, FiSettings, FiBarChart2, FiLink, FiZap, FiTarget,
  FiEdit3, FiShare2, FiTrendingUp, FiMail, FiShoppingCart,
  FiLayout, FiCheckCircle, FiPlus
} from "react-icons/fi";

// Map label keywords to icons
const LABEL_ICONS = {
  "keyword": <FiSearch />,
  "on-page": <FiSettings />,
  "technical": <FiSettings />,
  "content": <FiEdit3 />,
  "off-page": <FiLink />,
  "link": <FiLink />,
  "ai": <FiZap />,
  "ppc": <FiTarget />,
  "campaign": <FiTarget />,
  "audience": <FiBarChart2 />,
  "performance": <FiBarChart2 />,
  "social": <FiShare2 />,
  "email": <FiMail />,
  "ecommerce": <FiShoppingCart />,
  "web": <FiLayout />,
  "design": <FiLayout />,
  "strategy": <FiTrendingUp />,
  "planning": <FiTrendingUp />,
  "distribution": <FiShare2 />,
  "optimization": <FiSettings />,
  "tracking": <FiBarChart2 />,
  "testing": <FiCheckCircle />,
};

function getLabelIcon(label) {
  const lower = label.toLowerCase();
  for (const [key, icon] of Object.entries(LABEL_ICONS)) {
    if (lower.includes(key)) return icon;
  }
  return <FiPlus />;
}

const ServiceDetailSection = ({ isReversed, label, title, description, longDescription, image, listItems, bgLight }) => {
  const slideInLeft = {
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.8, ease: "easeOut" },
  };

  const slideInRight = {
    initial: { opacity: 0, x: 50 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true, amount: 0.3 },
    transition: { duration: 0.8, ease: "easeOut" },
  };

  return (
    <section className={`service-detail ${isReversed ? "service-detail-alt" : ""} ${bgLight ? "service-detail-bg-light" : ""}`}>
      <div className="service-detail-inner">
        <motion.div className="service-detail-copy" {...(isReversed ? slideInRight : slideInLeft)}>
          {label && (
            <span className="service-detail-label">
              <span className="service-detail-label-icon">{getLabelIcon(label + " " + title)}</span>
              {label}
            </span>
          )}
          <h2 className="mb-4">{title}</h2>
          <p className="mb-6">{description}</p>
          {longDescription && <p>{longDescription}</p>}
          {listItems && (
            <ul className="service-detail-list">
              {listItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}
        </motion.div>

        <motion.div className="service-detail-visual" {...(isReversed ? slideInLeft : slideInRight)}>
          <div className="service-detail-pill-container">
            <img src={image} alt={title} className="service-detail-pill-img" />
            <div className="service-detail-deco-plus"><FiPlus /></div>
            <div className="service-detail-deco-star-1">✷</div>
            <div className="service-detail-deco-star-2">✷</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceDetailSection;
